<template>
  <div class="main-bar w-xs p-2 text-left">
    <div class="relative text-md flex justify-center w-full p-1 pr-4 rounded-md border"
    style="box-shadow: 0 0 .5em rgba(0, 0, 0, 0.3)"
    :class="{
      'bg-red-10/80 text-red-100 border-red-100': status=='error',
      'bg-green-10/80 text-green-100 border-green-100': status=='success',
      'bg-orange-10/80 text-orange-100 border-orange-100': status=='alert',
    }">
      <div class="font-bold absolute right-0 mr-3 cursor-pointer" @click="$emit('exit')">✖</div>
      <slot></slot>
    </div>
    
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed:{
    ...mapGetters({
      status: 'topMessageStatus'
    })
  },
  mounted() {
    setTimeout(()=>{
      this.$emit('exit')
    },3000)
  },
}
</script>

<style scoped>
.main-bar{
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
}
</style>